<template>
    <div class="dropzone dz-clickable" :id="dzid">
        <!--begin::Message-->
        <div class="dz-message needsclick">
        <div class="">
            <div>
            <!--begin::Icon-->
            <img :src="static('munna/assets/icons/gallery2.svg')" alt="Upload placeholder" class="">
            <!--end::Icon-->
            </div>
            <!--begin::Info-->
            <div class="ms-4">
            <h3 class="fs-12px fw-bold text-gray-900 mb-1">Click or Drag & Drop</h3>
            <span class="fs-8 fw-semibold text-lightgrey" v-html="supportedMessage"></span>
            </div>
        </div>
        <!--end::Info-->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dzid: {default: 'kt_dropzonejs_acincludes'},
        supportedMessage: {default: 'Document files are supported'},
    },
    mounted() {
        this.$emit("dz-mounted");
    },
}
</script>